define('modules/accounts/users/list/view',['require','exports','module','views/BaseView','../collection','./../modalCantCreate/view','app','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView");
  var Users = require("../collection");
  var ModalCompanyView = require("./../modalCantCreate/view");
  var app = require("app");

  var View = BaseView.extend({
    showNoActives: false,
    template: require("ldsh!./template"),
    events: {
      'click #createNewUser': 'createNewUser',
      "click .js-show-noactives": "toggleShowNoActives"
    },

    initialize: function () {
      if (this.collection) {
        this.listenTo(this.collection, "reset sync request error", this.render);
      }
    },

    canCreateUsers: function () {
      if (this.me.isSuperAdmim()) {
        return true;
      }

      var totalUsersCanCreate = 0, totalNumUsers = 0;
      var services = this.group.get('services');
      _.each(services, function (service) {
        if (service.activeServiceGroup) {
          totalUsersCanCreate = (parseInt(totalUsersCanCreate) + parseInt(service.maxUsers));
          totalNumUsers = (parseInt(totalNumUsers) + parseInt(service.numUsers));
        }
      });
      return (totalNumUsers < totalUsersCanCreate);
    },

    createNewUser: function (event) {
      event.preventDefault();
      if (this.canCreateUsers()) {
        app.router.navigate(this.getRouteNewUser(this.options.group.id), {trigger: true});
      } else {
        var modalview = new ModalCompanyView({me: this.me});
        $("#renderModalServices").html(modalview.render().el);
        $('#modalLimitService').modal('show');
      }
    },

    serialize: function () {
      return {
        users: this.getUsers(),
        collection: this.collection,
        showNoActives: this.showNoActives,
        groupId: this.options.group.id
      };
    },

    toggleShowNoActives: function (e) {
      this.showNoActives = e.currentTarget.checked;
      this.render();
    },

    getUsers: function () {
      var self = this,
        usersArray;
      usersArray = this.collection.filter(function (user) {
        return (self.showNoActives || user.get("active"));
      });
      return new Users(usersArray);
    },

    getRouteNewUser: function (groupId) {
      var route = 'accounts/user/new';
      if (groupId !== null)
        route += '/group/' + groupId;
      return route;
    }

  });

  module.exports = View;
});

